import type { OtpMode } from "../api/connectionHub.types";

export const OTP_MODE_LABELS: Record<OtpMode, string> = {
  none: "No OTP",
  email: "OTP on Email",
  mobile: "OTP on Mobile",
};
